<template>
  <section class="c-user-reward-report">
    <card class="data-card" :show-footer-line="true">
      <b-row no-gutters>
        <b-col no-gutters>
          <h1 class="card-header p-0 card-header-text pb-3">
            گردگیری
          </h1>
        </b-col>
      </b-row>
      <b-skeleton-table
        v-if="loading"
        :rows="10"
        :columns="4"
        :table-props="{ bordered: true, striped: true }"
      >
      </b-skeleton-table>
      <b-row v-if="!loading">
        <b-col class="no-col-margin" md="12">
          <!-- <h1 class="section-header">کیف های پول</h1> -->
          <b-card class="wallets-table" no-body>
            <b-table
              emptyText="تاریخچه ای یافت نشد"
              :items="histories"
              :fields="fields"
              show-empty
              responsive
              small
            >

              <template #cell(date)="row">
                {{ row.item.date }}
              </template>

              <template #cell(status)="row">
                <b-button size="sm" variant="outline-primary">
                  {{ row.item.status }}
                </b-button>
              </template>

              <template #cell(actions)="row">
                <b-button size="sm" variant="primary" @click="showDetails(row.item.id)">
                  نمایش جزییات
                </b-button>
              </template>
            </b-table>
          </b-card>
          <div class="paginationNav">
            <b-row>
              <b-col class="mt-4">
                <div class="overflow-auto">
                  <BasePagination
                    :showNext="showNext"
                    :showPrev="currentPage !== 0"
                    @onClick="handlePaginationClick"
                  />
                </div>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </card>
    <b-modal
      id="show-more"
      hide-footer
    >
      <div dir="rtl">
        <b-row class="mb-3" v-for="(item,index) in showMore.data" :key="index">
          <b-col :cols="5" class="bg-secondary p-2 rounded-sm">
            <div class="d-flex align-items-center justify-content-between">
              <div>
                <img :src="item.fromAssetImg" alt="" style="width: 32px">
                <span>  {{ item.fromAsset }} </span>
              </div>

              <span>  {{ item.fromAssetAmount }} </span>

            </div>
          </b-col>

          <b-col :cols="2">
            <small>
              تبدیل به
            </small>
          </b-col>
          <b-col :cols="5" class="bg-secondary p-2 rounded-sm">
            <div class="d-flex align-items-center justify-content-between">
              <div>
                <img :src="item.toAssetImg" alt="">
                <span>  {{ item.toAsset }} </span>
              </div>
              <span>  {{ item.toAssetAmount }} </span>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-modal>

  </section>
</template>

<script>

import CryptoIcons from "@/components/CryptoIcons";
import BasePagination from "@/components/BasePagination.vue";
import filterAndPaginate from "@/mixins/filterAndPaginate";
import FilterTransactions from "@/components/FilterTransactions";
import dateHelper from "@/utils/DateHelper";
import store from "@/store";
import {fetchDustingReportDetail, fetchDustingReports, fetchUserDustingReports} from "@/httpservices/Dusting";
import {addCommas} from "@persian-tools/persian-tools";

export default {
  name: "DustingReport",

  mixins: [filterAndPaginate],

  components: {
    CryptoIcons,
    FilterTransactions,
    BasePagination,
  },

  computed: {
    adminsAccessOnly() {
      return Boolean(store.getters['isSuperAdmin']);
    }
  },

  data() {
    return {
      imageUrl: "/img/coins/svg/",

      STATUS: {
        Filled: "تکمیل شده",
        Canceled: "کنسل شده",
        Open: "باز",
      },

      fields: [
        {
          key: "date",
          label: "تاریخ",
          sortable: false,
          class: "text-center",
        },
        {
          key: "status",
          label: "وضعیت",
          sortable: false,
          class: "text-center",
        },
        {
          key: "user",
          label: "کاربر",
          sortable: false,
          class: "text-center",
        },
        {
          key: "amount",
          label: "مجموع تومانی",
          sortable: false,
          class: "text-center",
        },
        {
          key: "status",
          label: "وضعیت تراکنش",
          sortable: false,
          class: "text-center",
        },
        {
          key: "actions",
          label: "عملیات",
          sortable: false,
          class: "text-center",
        },
      ],
      histories: [],
      loading: false,
      currentPage: 0,
      filterData: {
        fromDate: "",
        toDate: "",
        pageSize: 25,
      },
      showMore: {
        modal: false,
        loading: true,
        data: [],
      }
    };
  },

  mounted() {
    this.getHistory();
    // emit in user wallets on manual action
    this.$root.$on("manualWalletsAction", () => {
      this.getHistory();
    });
  },

  methods: {
    async getHistory() {
      this.loading = true;
      try {
        const res = (await fetchUserDustingReports({
          accountId: this.$route.params.id,
          page: this.currentPage,
          Start: this.filterData.fromDate,
          End: this.filterData.toDate,
        })).data;
        this.histories = res.data.map(item => {
          return {
            id: item.id,
            date: dateHelper.faDateTime(item.date),
            status: this.STATUS[item.status] || 'نا معلوم',
            toAmount: item.toAmount,
            fromAmount: item.fromAmount,
            amount: (item.amount > 1 ? addCommas(Number(item.amount).toFixed(0)) : item.amount) + " تومان ",
          }
        });
      } catch (e) {
        console.log(e)
      }
      this.loading = false;
    },

    async showDetails(orderId) {
      this.showMore = {
        ...this.showMore,
        modal: true,
        loading: true,
        data: [],
      }
      this.$bvModal.show('show-more');
      try {
        const res = (await fetchDustingReportDetail(orderId)).data || [];
        //result equal to :
        // amount:"10.0"
        // asset:"TRX"
        // date:"2022-12-07T13:53:50.79838"
        // id:"49160697-c828-4c4e-9c2b-aafc183d0015"
        // orderId:"209e67ee-9232-40ed-8130-cfde775a5b08"
        // toAssetAmount:"15664.3200000"
        // unitPriceInUsdt:"0.0522144"
        this.showMore.data = res.map(item => {
          return {
            fromAssetImg: `/img/coins/svg/${item.asset.toLowerCase()}_.svg`,
            fromAsset: item.asset,
            fromAssetAmount: item.amount,
            toAssetImg: `/img/coins/svg/irt_.svg`,
            toAsset: 'IRT',
            toAssetAmount: item.toAssetAmount > 1 ? addCommas(Number(item.toAssetAmount).toFixed(0)) : item.toAssetAmount,
          }
        })
      } catch (e) {
        console.log(e)
      }
      this.showMore.loading = false;
    }
  },
};
</script>

<style lang="scss">
.c-user-reward-report {
  .icon {
    margin: 0 8px;
    width: 32px;
    min-width: 32px;
    height: 32px;
    background-color: transparent;
    border-radius: 8px;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.14);
  }

  .card-detail-container {
    .row {
      margin-bottom: 18px;
    }

    .last {
      margin-bottom: 0;
    }

    .info {
      font-size: 16px;
      font-weight: 400;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: right;
      color: #757575;
      text-align: right;
      margin-bottom: 8px;
    }

    .value {
      font-size: 16px;
      font-weight: 400;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: right;
      color: #000;
      text-align: left;
    }
  }

  .bank-logo {
    width: 34px;
    height: 34px;
  }

  .more-info-header-button {
    background-color: #fff;
  }

  @media (max-width: 990px) {
    .section-header {
      font-size: 24px;
      font-weight: 400;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: right;
      color: #757575;
      margin-bottom: 49px;
    }
  }

  @media (min-width: 990px) {
    .section-header {
      font-size: 24px;
      font-weight: 400;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: right;
      color: #757575;
      margin-bottom: 49px;
    }
  }

  .data-card {
    @media (max-width: 991px) {
      margin-top: 16px;
    }
  }

  #add-card-modal {
    .modal-body {
      text-align: right;
      direction: rtl;
    }
  }
}
</style>
